import type { CreateChatThreadResponseAllOfCurrentUserStatusStatus } from './createChatThreadResponseAllOfCurrentUserStatusStatus';

export type CreateChatThreadResponseAllOfCurrentUserStatus = {
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  invitedBy?: string | null;
  /** @nullable */
  requestedAt?: string | null;
  status: CreateChatThreadResponseAllOfCurrentUserStatusStatus;
};
